export default __webpack_public_path__ + "static/media/ic-computers.fe2eac86.svg";